/* eslint-disable no-empty-pattern */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { Form, Input, Result, Checkbox, Tooltip } from 'antd';
import Image from 'next/image';

import { useEffect, useRef, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { mask } from 'remask';
import { Icon } from 'semantic-ui-react';
import { useLocalStorage } from 'usehooks-ts';

import Button from '@components/ButtonDynamic';
import Footer from '@components/Footer';
import Navbar from '@components/Navbar';
import NewsLetter from '@components/NewsLetter';
import Notify from '@components/Notify';
import SkeletonAsync from '@components/Skeleton';
import SpotLight from '@components/SpotLight';
import formatCurrency from '@helpers/formatCurrency';
import api from '@services/api';

import NewCarouselImage from '@components/CarouselImage/NewCarouselImage';
import EmbedModal from '@components/EmbedModal';
import ModalDataClient from '@components/modalDataClientOito';
import { useAppContexto } from 'contexts/AppContext';
import useConfiguracoes from 'contexts/hooks/useConfiguracoes';
import benfeitoriasImovel from 'types/benfeitoriasImovel';
import { ImmobileProps } from 'types/immobileProps';
import fetchAuthOito from '@services/fetch-authOito';

const CheckboxGroup = Checkbox.Group;
const plainOptions = ['Whatsapp', 'E-mail'];

const area =
  'https://locare.s3.sa-east-1.amazonaws.com/sites/common/ruler.png?size=small';
const suites =
  'https://locare.s3.sa-east-1.amazonaws.com/sites/common/banheira.png?size=small';
const quarto =
  'https://locare.s3.sa-east-1.amazonaws.com/sites/common/cama-de-casal.png?size=small';
const garage =
  'https://locare.s3.sa-east-1.amazonaws.com/sites/common/garagem.png?size=small';
const garageOther =
  'https://locare.s3.sa-east-1.amazonaws.com/sites/my-broker/garage.png';

const ImmobileDetails = ({ props, dataImoveis }) => {
  const [loadPage, setLoadPage] = useState(true);
  const [loading, setIsLoading] = useState(false);
  const [dataImovel, setDataImovel] = useState<ImmobileProps>(null);
  const [checkedList, setCheckedList] = useState(plainOptions);
  const [exibirModal, setExibirModal] = useState(false);
  const [imagensModal, setImagensModal] = useState([]);
  const [fileList] = useState(props?.imagens || []);
  const [maisFiltros, setMaisFiltros] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showTourModal, setShowTourModal] = useState(false);
  const [form] = Form.useForm();
  const [empresaId, setEmpresaId] = useLocalStorage(
    'empresaId',
    props?.empresa?.id || null,
  );

  const [isShowModalDataCliente, setIsShowModalDataCliente] = useState(false);
  const [isTitleModal, setIsTitleModal] = useState('');
  const [isDataFinancial, setIsDataFinancial] = useState();
  const [isForms, setIsForms] = useState('');
  const [authLatitude, setAuthLatitude] = useState();


  useEffect(() => {
    if (props) {
      setDataImovel(props);
      setLoadPage(false);

      setEmpresaId(props?.empresa?.id);
    } else {
      setTimeout(() => {
        setLoadPage(false);
      }, 1500);
    }
  }, [props]);

  useEffect(() => {
    // Adiciona um ouvinte de evento quando o componente é montado
    const handleSeguirButtonClick = (event) => {
      // Atualiza o estado do modal quando o evento é ouvido
      setIsShowModalDataCliente(true);
      const { productCategory, form, product } = event.detail;
      setIsTitleModal(`Dados Simulação - ${product.bank.name} - ${product.amortization} `)
      setIsDataFinancial(productCategory);
      setIsForms(form);
    };

    window.addEventListener('seguirButtonClick', handleSeguirButtonClick);

    // Remove o ouvinte de evento quando o componente é desmontado
    return () => {
      window.removeEventListener('seguirButtonClick', handleSeguirButtonClick);
    };
  }, []);

  const exibirCarouselModal = (index) => {
    if (index && fileList.length) {
      let selectedImage = fileList[index];
      let newImages = fileList.filter(
        (f) => f.arquivo !== selectedImage.arquivo,
      );
      newImages.unshift(selectedImage);
      setImagensModal(newImages);
    } else {
      setImagensModal(fileList);
    }
    setExibirModal(true);
  };

  const onChangeContact = (list) => {
    setCheckedList(list);
  };

  const sendContact = () => {
    setIsLoading(true);

    form
      .validateFields()
      .then(async (dados) => {
        const payload = {
          tipoMidia: 103,
          nome: dados?.name,
          email: dados?.email,
          telefone: dados?.celular,
          celular: dados?.celular,
          codImovel: props?.codImovel,
          mensagem: `Olá me chamo ${dados?.name} e o meu número de contato é ${dados?.celular}, e-mail ${dados?.email}, encontrei o imóvel ${props?.codImovel} atráves do seu site! poderia entrar em contato e me fornecer maiores informações ? Obrigado !`,
          empresaId: props?.empresa?.id,
        };

        await api
          .post('/atendimento/lead', payload)
          .then(() => {
            setIsLoading(false);
            Notify('success', '', 'Parabéns, dados enviados com sucesso!');
          })
          .catch((error) => {
            setIsLoading(false);
            if (
              error?.response?.data?.error?.Cliente ==
              'Cliente já possui atendimento em aberto.'
            )
              Notify(
                'error',
                '',
                'Já exite um atendimento em aberto, por favor, aguarde o nosso contato.',
              );
            else
              Notify('error', '', 'Não foi possível enviar, tente mais tarde');
          });
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const RenderPhoneNunber = () => {
    const ddd = props?.empresa?.telefone?.slice(0, 2);
    const cellphone = props?.empresa?.telefone?.slice(2, 14);
    const pattern = cellphone?.length === 8 ? '9999-9999' : '99999-9999';

    if (props?.empresa?.telefone) {
      return (
        <div>
          <p
            className="mt-4 mb-0"
            style={{
              color: '#062C44',
              fontWeight: '600',
              fontSize: '16px',
            }}>
            {props?.empresa?.nome}
          </p>
          <p
            className="mt-1"
            style={{
              color: '#062C44',
              fontSize: '16px',
            }}>
            {props?.empresa?.pessoaContato}
          </p>
          <p
            className="my-4"
            style={{
              color: '#062C44',
              fontWeight: '600',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}>
            <i
              style={{ color: '#25D366', fontSize: '28px' }}
              className="bi bi-whatsapp"></i>
            <a
              target="_blank"
              href={`https://wa.me/55${ddd}${cellphone}`}
              style={{
                paddingLeft: '10px',
                color: '#062C44',
                fontWeight: '600',
                fontSize: '22px',
              }}>
              {` (${ddd}) `}
              {mask(cellphone, pattern)}
            </a>
          </p>
        </div>
      );
    }

    return null;
  };

  const hasImoveis = Object.keys(dataImovel || [])?.length >= 1 || false;

  const hasFilter = props?.caracteristica?.caracteristicas?.length > 300;

  const defaultBeneficios = [];

  if (props?.caracteristica?.piscina) defaultBeneficios.push('PI');
  if (props?.caracteristica?.armarios) defaultBeneficios.push('AR');
  if (props?.caracteristica?.despensas) defaultBeneficios.push('DE');
  if (props?.caracteristica?.mobiliado) defaultBeneficios.push('MO');
  if (props?.caracteristica?.salasDeJantar) defaultBeneficios.push('SJ');
  if (props?.caracteristica?.closets) defaultBeneficios.push('CL');
  if (props?.caracteristica?.escritorios) defaultBeneficios.push('ES');
  if (props?.caracteristica?.lavabos) defaultBeneficios.push('LA');
  if (props?.caracteristica?.dces) defaultBeneficios.push('DC');
  if (props?.caracteristica?.banheirosServico) defaultBeneficios.push('BS');
  if (props?.caracteristica?.varandas) defaultBeneficios.push('VA');
  if (props?.caracteristica?.armarioCozinha) defaultBeneficios.push('AC');
  if (props?.caracteristica?.churrasqueiras) defaultBeneficios.push('CH');
  if (props?.caracteristica?.saloesFesta) defaultBeneficios.push('SF');
  if (props?.caracteristica?.saloesDeGinastica) defaultBeneficios.push('SG');
  if (props?.caracteristica?.quadraDeEsportes) defaultBeneficios.push('QE');
  if (props?.caracteristica?.quintal) defaultBeneficios.push('QU');
  if (props?.caracteristica?.copa) defaultBeneficios.push('CO');
  if (props?.caracteristica?.redeEsgoto) defaultBeneficios.push('RE');
  if (props?.caracteristica?.minhaCasaMinhaVida) defaultBeneficios.push('MV');

  function transformYouTubeURL(url) {
    if (!url) return null;
    const regex1 =
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/;
    const match1 = url.match(regex1);

    if (match1 && match1[1]) {
      return `https://www.youtube.com/embed/${match1[1]}?autoplay=1`;
    }

    const regex2 = /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]{11})/;
    const match2 = url.match(regex2);

    if (match2 && match2[1]) {
      return `https://www.youtube.com/embed/${match2[1]}?autoplay=1`;
    }

    return url;
  }

  const urlVideo = transformYouTubeURL(props?.url);
  const urlTour360 = transformYouTubeURL(props?.url360);

  const simulatorRef = useRef(null);

  const { configuracoes: configuracoesData } = useConfiguracoes()
  const { configuracoes, setConfiguracoes } = useAppContexto();

  useEffect(() => {
    setConfiguracoes(configuracoesData)
  }, [configuracoesData])

  const secondaryColor = configuracoes?.secondaryColor || '#f99f1b';

  useEffect(() => {
    const changeTotalValue = () => {
      const valorTotalInput = document?.getElementById(
        'valorTotal',
      ) as HTMLInputElement;

      if (valorTotalInput) {
        valorTotalInput.value = String(dataImovel?.valorVenda || '');
      }
    };

    if (simulatorRef.current) {
      const targetNode = simulatorRef?.current;
      const config = { childList: true, subtree: true };

      const callback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            if (mutation.addedNodes.length > 0) {
              changeTotalValue();
            }
          }
        }
      };

      const observer = new MutationObserver(callback);
      observer?.observe(targetNode, config);

      return () => {
        observer.disconnect();
      };
    }
  }, [simulatorRef]);

  useEffect(() => {
    const fetchAuth = async () => {
      try {
        const authData = await fetchAuthOito();
        setAuthLatitude(authData);
      } catch (error) {
        console.error('Erro ao buscar autenticação:', error);
      }
    };

    fetchAuth();
  }, []);

  return (
    <>
      {urlVideo && (
        <EmbedModal
          title={`Vídeo - ${props.tituloAmigavel}`}
          url={transformYouTubeURL(urlVideo)}
          isOpen={showVideoModal}
          onOk={() => setShowVideoModal(false)}
          onCancel={() => setShowVideoModal(false)}
        />
      )}
      {urlTour360 && (
        <EmbedModal
          title={`Tour 360° - ${props.tituloAmigavel}`}
          url={urlTour360}
          isOpen={showTourModal}
          onOk={() => setShowTourModal(false)}
          onCancel={() => setShowTourModal(false)}
        />
      )}
      <Navbar hasSearch />
      {loadPage ? (
        <div className="spotlight">
          <Container>
            <div
              className="main-panel"
              id="main-panel"
              style={{ marginTop: '50px' }}>
              <div className="content" style={{ paddingTop: '30px' }}>
                <Row>
                  <Col>
                    <div className="single-location">
                      <Card className="p-2" style={{ marginTop: '30px' }}>
                        <CardBody>
                          <SkeletonAsync cardShadowless />
                        </CardBody>
                      </Card>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        </div>
      ) : null}
      {!loadPage && hasImoveis ? (
        <>
          <section className="spotlight">
            <NewCarouselImage fileList={fileList} />
            <Container>
              <div
                className="py-4"
                style={{ margin: isDesktop ? '30px 0 20px 0' : '15px 0 0 0' }}>
                <Row className="mb-4">
                  <Col xs="12" md="8">
                    <div>
                      <Row>
                        <Col xs="12" md="2">
                          <Button
                            disabled={!urlVideo}
                            className={isDesktop ? 'm-0' : 'my-1'}
                            size={isDesktop ? 'mini' : 'medium'}
                            icon
                            labelPosition="left"
                            fluid
                            style={{
                              backgroundColor: secondaryColor,
                              color: 'white',
                            }}
                            onClick={() => {
                              setShowVideoModal(true);
                            }}>
                            <Icon name="video" />
                            Vídeos
                          </Button>
                        </Col>
                        <Col xs="12" md="2">
                          <Tooltip title="Funcionalidade em construção...">
                            <Button
                              className={isDesktop ? 'm-0' : 'my-1'}
                              size={isDesktop ? 'mini' : 'medium'}
                              icon
                              labelPosition="left"
                              fluid
                              style={{
                                backgroundColor: secondaryColor,
                                color: 'white',
                              }}
                              onClick={() => { }}>
                              <Icon name="map marker" />
                              Mapa
                            </Button>
                          </Tooltip>
                        </Col>
                        <Col xs="12" md="2">
                          <Button
                            disabled={!urlTour360}
                            className={isDesktop ? 'm-0' : 'my-1'}
                            size={isDesktop ? 'mini' : 'medium'}
                            icon
                            labelPosition="left"
                            fluid
                            style={{
                              backgroundColor: secondaryColor,
                              color: 'white',
                            }}
                            onClick={() => setShowTourModal(true)}>
                            <Icon name="video play" />
                            Tour 360º
                          </Button>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs="12" md="8">
                          <div className="immobile-content-details my-2 pt-0">
                            <span>
                              Imóveis {` > ${props?.tipoImovel?.descricao}`}{' '}
                              {` > ${props?.logradouro?.bairro?.cidade?.nome}`}
                            </span>
                            <h2 className="my-2">{props?.tituloAmigavel}</h2>
                            {props?.endereco?.condominio ? (
                              <div className="immobile-content-details-area mb-0">
                                <p>
                                  Condomínio:{' '}
                                  <span>
                                    {props?.endereco?.condominio?.nome}
                                  </span>
                                </p>
                                <p>
                                  Valor do Condomínio:{' '}
                                  <span>
                                    {props?.valorCondominio
                                      ? ' ' +
                                      formatCurrency(props?.valorCondominio)
                                      : ' Não informado'}
                                  </span>
                                </p>
                              </div>
                            ) : null}
                            <span>{props?.logradouro?.bairro?.nome}</span>
                            <span>
                              {`, ${props?.logradouro?.bairro?.cidade?.nome}`} -{' '}
                              {props?.logradouro?.bairro?.cidade?.estadoId}
                            </span>
                          </div>
                        </Col>
                      </Row>

                      <div className="immobile-icons-container">
                        <div className="d-flex">
                          <div>
                            <Image src={area} width={25} height={25} />
                          </div>
                          <span className="icon-details mx-3 my-1">
                            {props?.caracteristica?.areaConstruida ||
                              props?.caracteristica?.areaPrivada}{' '}
                            {
                              props?.caracteristica?.areaPrivadaUniMedida
                                ?.descricao
                            }
                          </span>
                        </div>
                        <div className="d-flex">
                          <div>
                            <Image src={suites} width={25} height={25} />
                          </div>
                          <span className="icon-details mx-3 my-1">
                            Suites:{' '}
                            {props?.caracteristica?.quantidadeSuites || 0}
                          </span>
                        </div>
                        <div className="d-flex">
                          <div>
                            <Image src={quarto} width={25} height={25} />
                          </div>
                          <span className="icon-details mx-3 my-1">
                            Quartos:{' '}
                            {props?.caracteristica?.quantidadeQuartos || 0}
                          </span>
                        </div>
                        <div className="d-flex">
                          <div>
                            <Image src={garage} width={25} height={25} />
                          </div>
                          <span className="icon-details mx-3 my-1">
                            Garagem:{' '}
                            {props?.caracteristica?.vagasGaragem ||
                              0 +
                              props?.caracteristica
                                ?.vagasGaragemDescobertas ||
                              0}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Row noGutters>
                      <Col xs="12" md="11">
                        <div className="immobile-content-details mt-4">
                          <p className="my-4">
                            <div
                              className="imobile-desc"
                              dangerouslySetInnerHTML={{
                                __html:
                                  props?.caracteristica?.caracteristicas?.replace(
                                    /\n/g,
                                    '<br />',
                                  ),
                              }}
                            />
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row className="my-3">
                      <Col xs="12">
                        <div className="immobile-content-details-area">
                          {props?.caracteristica?.areaTerreno ||
                            props?.caracteristica?.areaTotal ? (
                            <p>
                              Área Total:{' '}
                              <span>
                                {' '}
                                {props?.caracteristica?.areaTerreno ||
                                  props?.caracteristica?.areaTotal}{' '}
                                {
                                  props?.caracteristica?.areaTotalUniMedida
                                    ?.descricao
                                }
                              </span>
                            </p>
                          ) : null}
                          {props?.caracteristica?.areaConstruida ||
                            props?.caracteristica?.areaPrivada ? (
                            <p>
                              Área Privada:{' '}
                              <span>
                                {props?.caracteristica?.areaConstruida ||
                                  props?.caracteristica?.areaPrivada}{' '}
                                {
                                  props?.caracteristica?.areaPrivadaUniMedida
                                    ?.descricao
                                }
                              </span>
                            </p>
                          ) : null}
                        </div>

                        {defaultBeneficios?.length > 0 && (
                          <div className="immobile-content-more-details">
                            <h2 className="mt-2">Mais Características</h2>
                            <ul>
                              {defaultBeneficios?.map((b) => (
                                <li>
                                  {
                                    benfeitoriasImovel?.filter(
                                      (v) => v.value === b,
                                    )[0].label
                                  }
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col xs="12" md="11">
                        <FinanceBanner
                          title="Financie esse imóvel"
                          subTitle="Quer simular o financiamento deste imóvel ? entre em contato agora e receba ajuda especializada !"
                          textButton="Simule o financiamento"
                        />
                      </Col>
                    </Row> */}
                  </Col>
                  <Col xs="12" md="4">
                    <div className="form-immobile-details">
                      <span>
                        Código do imóvel: <strong>{props?.codImovel}</strong>
                      </span>
                      <br />
                      <br />
                      {!!dataImovel?.valorAluguel && (
                        <div>
                          <h2>Valor Aluguel</h2>
                          <span className="immobile-price">
                            {formatCurrency(dataImovel?.valorAluguel)}
                          </span>
                        </div>
                      )}
                      {!!dataImovel?.valorAluguel &&
                        !!dataImovel?.valorVenda && <br />}
                      {!!dataImovel?.valorVenda && (
                        <div>
                          <h2>Valor Venda</h2>
                          <span className="immobile-price">
                            {formatCurrency(dataImovel?.valorVenda)}
                          </span>
                          <input
                            type="hidden"
                            id="valorVenda"
                            value={dataImovel?.valorVenda}
                          />
                        </div>
                      )}
                      {/* {(props?.caracteristica?.areaConstruida ||
                        props?.caracteristica?.areaPrivada) && (
                          <div className="pt-2">
                            Valor M²:{' '}
                            <strong>
                              {formatCurrency(
                                dataImovel?.valorVenda /
                                props?.caracteristica?.areaConstruida ||
                                props?.caracteristica?.areaPrivada ||
                                1,
                            )}
                          </strong>
                        </div>
                      )} */}
                      {(dataImovel?.valorCondominio ||
                        dataImovel?.endereco?.condominio?.valor) && (
                          <div>
                            Condomínio:{' '}
                            <strong>
                              {formatCurrency(
                                dataImovel?.valorCondominio ||
                                dataImovel?.endereco?.condominio?.valor,
                              )}
                              /mês
                            </strong>
                          </div>
                        )}
                      {dataImovel?.valorIptu && (
                        <div>
                          IPTU:{' '}
                          <strong>
                            {formatCurrency(dataImovel?.valorIptu)}/
                            {dataImovel?.condicoesPgtoIptu === 2
                              ? 'ano'
                              : 'mês'}
                          </strong>
                        </div>
                      )}
                      <RenderPhoneNunber />

                      <Form form={form}>
                        <Row>
                          <Col xs="12" className="my-2">
                            <span className="heading-small text-muted">
                              <small>Nome</small>
                            </span>
                            <Form.Item
                              className="mb-2"
                              name="name"
                              rules={[
                                {
                                  required: true,
                                  message: 'Favor informar o Nome',
                                },
                              ]}>
                              <Input />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" md="6" className="my-2">
                            <span className="heading-small text-muted">
                              <small>Email</small>
                            </span>
                            <Form.Item
                              className="mb-2"
                              name="email"
                              rules={[
                                {
                                  required: true,
                                  type: 'email',
                                  message: 'Favor inserir um E-mail válido',
                                },
                              ]}>
                              <Input placeholder=" Email" />
                            </Form.Item>
                          </Col>
                          <Col xs="12" md="6" className="my-2">
                            <span className="heading-small text-muted">
                              <small>Telefone</small>
                            </span>
                            <Form.Item
                              className="mb-2"
                              name="celular"
                              rules={[
                                {
                                  required: true,
                                  message: 'Favor informar o telefone',
                                },
                                {
                                  pattern: /^(?:(55\d{2})|\d{2})[6-9]\d{8}$/,
                                  message: 'Formato inválido',
                                },
                              ]}>
                              <Input
                                type="number"
                                placeholder=" DDD + Telefone"
                                style={{
                                  width: '100%',
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <span className="heading-small text-muted mt-2">
                            <small>Como prefere receber o contato ?</small>
                          </span>
                          <Form.Item className="mx-3" name="contactOption">
                            <CheckboxGroup
                              options={plainOptions}
                              value={checkedList}
                              onChange={onChangeContact}
                            />
                          </Form.Item>
                        </Row>
                      </Form>
                      <Row className="mt-4 justify-content-md-center no-gutters">
                        <Col xs="12">
                          <Button
                            icon
                            labelPosition="left"
                            fluid
                            color="blue"
                            isloading={loading.toString()}
                            loadtext="Enviando..."
                            onClick={() => sendContact()}>
                            <Icon name="send" />
                            Receber informações
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                <div
                  className=""
                  style={{
                    display: `${props?.utilizaSimulacao && props?.valorVenda ? 'flex' : 'none'}`,
                    flexDirection: 'column',
                  }}>
                  <ModalDataClient isOpen={isShowModalDataCliente} onCancel={() => { setIsShowModalDataCliente(false); }}
                    title={isTitleModal} data={isDataFinancial} valueForms={isForms} responsePartner={authLatitude}
                    partnerCnpj={props.empresa.cnpj} />

                  <div className="spot-title-container">
                    <div className="spot-title-content">
                      <div className="spot-title">
                        Simulação de crédito imobiliário
                      </div>
                    </div>
                  </div>
                  <div id="simulator-oito" ref={simulatorRef}></div>
                </div>
              </div>

              <SpotLight
                dataImmobile={dataImoveis}
                title="Imóveis em destaque"
              />
            </Container>
          </section>
        </>
      ) : null}
      {!hasImoveis && !loadPage ? (
        <section className="spotlight">
          <div
            className="page-not-found hero-overly"
            style={{ minHeight: '50vh', paddingTop: '130px' }}>
            <div className="d-flex flex-column justify-content-center h-100">
              <Container>
                <Result
                  status="404"
                  subTitle="Desculpe, Imóvel não encontrado!"
                />
              </Container>
            </div>
          </div>
        </section>
      ) : null}
      <NewsLetter />
      <Footer />
    </>
  );
};

export default ImmobileDetails;
